module.exports = __webpack_public_path__ + "static/media/icone-jurisprudencia.e35ab4d3.svg";